import { Typography } from '@altibox/lte-salgskanaler-design-system-component-lib';
import { styled } from 'styled-components';

import { breakpointTablet } from 'src/styles/breakpoints';
import { spacing4, spacing5 } from 'src/styles/spacing';

export const StyledDescription = styled(Typography)`
  margin-bottom: ${spacing4};
`;

export const StyledContent = styled.div`
  margin-bottom: ${spacing4};

  @media (min-width: ${breakpointTablet}) {
    margin-bottom: ${spacing5};
  }
`;
